

import React, { useState, useEffect } from 'react';
import './CoursesInPlace.css';
import bazeleconta from '../images/bazelecontaone.png';
import contafinanciaraone from '../images/contafinanciaraone.png';
import accountsplan from '../../../imagesHome/accountsplan.png';
import gamerules from '../../../imagesHome/game-rules.png';
import accountancyfirst from '../../../imagesHome/game02.png';

const mockCourses = [
  { id: 1, name: 'Bazele contabilitatii', blurred: false, icon: bazeleconta, color: 'teal' },
  { id: 2, name: 'Contabilitate financiara', blurred: false, icon: contafinanciaraone, color: 'orange' },
  { id: 3, name: 'Planul de conturi', blurred: false, icon: accountsplan, color: 'green' },
  { id: 4, name: 'Regulile de functionare', blurred: false, icon: gamerules, color: 'purple' },
  { id: 5, name: 'Tipuri de conturi', blurred: false, icon: accountancyfirst, color: 'blue' },
];

export default function CoursesInPlace() {
  const [enrolledCourses, setEnrolledCourses] = useState(() => {
    const saved = localStorage.getItem('enrolledCourses');
    return saved ? JSON.parse(saved) : [1]; // Default: Bazele contabilitatii
  });

  useEffect(() => {
    localStorage.setItem('enrolledCourses', JSON.stringify(enrolledCourses));
    // Emit custom event for BCButtonWithDropdown to listen
    window.dispatchEvent(new CustomEvent('coursesUpdated', { detail: enrolledCourses }));
  }, [enrolledCourses]);

  const toggleCourseEnrollment = (courseId) => {
    localStorage.setItem('selectedCourseId', String(courseId));
    window.dispatchEvent(new CustomEvent('courseSelected', { detail: courseId }));

    if (enrolledCourses.includes(courseId)) {
      return;
    }

    const updatedCourses = [...enrolledCourses, courseId];
    setEnrolledCourses(updatedCourses);
    localStorage.setItem('enrolledCourses', JSON.stringify(updatedCourses));
    window.dispatchEvent(new CustomEvent('coursesUpdated', { detail: updatedCourses }));
  };

  return (
    <div className="coursesinplace-container">
      <div className="cursuri-title">Cursuri disponibile</div>
     
      <div className="coursesinplace-grid">
        {mockCourses.map((course) => {
          const isEnrolled = enrolledCourses.includes(course.id);
          const canClick = !course.blurred;
          const colorClass = course.color ? ` color-${course.color}` : '';
          
          return (
          <div 
            key={course.id} 
            className={`coursesinplace-card${!course.blurred ? ' current' : ''}${colorClass}`}
            onClick={() => canClick && toggleCourseEnrollment(course.id)}
            style={{ cursor: canClick ? 'pointer' : 'default' }}
          > 
            {isEnrolled && (
              <div className="coursesinplace-current-badge">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M7 10L9 12L13 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            )}
            <div className={`coursesinplace-card-icon${!course.blurred ? ' current' : ''}${colorClass}`}>
              {course.blurred ? (
                <div className="coursesinplace-card-blur" />
              ) : (
                <img src={course.icon} alt={course.name} style={{ width: 48, height: 48, objectFit: 'contain' }} />
              )}
            </div>
            <div className={`coursesinplace-card-title${!course.blurred ? ' current' : ''}`}>
              {course.blurred ? <div className="coursesinplace-card-blur-bar" /> : course.name}
            </div>
          
          </div>
          );
        })}
      </div>
    </div>
  );
}
